import { render, staticRenderFns } from "./SumChart.vue?vue&type=template&id=24d3ae58&"
import script from "./SumChart.vue?vue&type=script&lang=js&"
export * from "./SumChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports